import { useTranslation } from "react-i18next";
import { Icon } from "@/shared/ui";

type Props = {
  livingCapacity: number;
  garageCapacity: number;
  livingCount?: number;
  garageCount?: number;
};
export default function OfferEstateInfo({
  livingCapacity,
  garageCapacity,
  livingCount,
  garageCount,
}: Props) {
  const { t } = useTranslation("offer");

  return (
    <div className="grid grid-cols-2 gap-1.5">
      <div className="flex items-center justify-between h-14.5 bg-gray/10 rounded-[0.5rem] px-3.5">
        <div className="flex flex-col">
          <p className="text-14 font-bold text-inverted">
            {typeof livingCount === "number" && (
              <span>
                <span className="text-accent-solid">{livingCount}</span>/
              </span>
            )}
            {livingCapacity}
          </p>
          <div className="text-11 font-medium text-gray/60 uppercase">
            {t("offer.estate.info.livingCapacity")}
          </div>
        </div>
        <Icon category="home-menu" name="user" className="w-5 bg-inverted/50" />
      </div>
      <div className="flex items-center justify-between h-14.5 bg-gray/10 rounded-[0.5rem] px-3.5">
        <div className="flex flex-col">
          <p className="text-14 font-bold text-inverted">
            {typeof garageCount === "number" && (
              <span>
                <span className="text-accent-solid">{garageCount}</span>/
              </span>
            )}
            {garageCapacity}
          </p>
          <div className="text-11 font-medium text-gray/60 uppercase">
            {t("offer.estate.info.garageCapacity")}
          </div>
        </div>
        <Icon category="home-menu" name="garage" className="w-5 bg-inverted/50" />
      </div>
    </div>
  );
}
